/**
 * /tenants/$slug/agents/approval-thresholds — the tenant agent-T3 default policy
 * editor (AI Agents → Agent governance). Read gated agents.read; writes are
 * step-up-gated server-side.
 */

import { createFileRoute } from "@tanstack/react-router";
import { fetchAgentApprovalPolicy } from "@/features/agent-approval-thresholds/queries";
import { fetchAgentConsentPolicy } from "@/features/agent-consent-policy/queries";
import { ApprovalThresholdsPage } from "@/features/agent-approval-thresholds/pages/approval-thresholds-page";

export const Route = createFileRoute("/_authed/tenants/$slug/agents/approval-thresholds")({
  loader: ({ context }) =>
    Promise.all([
      context.queryClient.ensureQueryData({
        queryKey: ["agents", "approval-policy", context.tenant.id],
        queryFn: () => fetchAgentApprovalPolicy(context.tenant.id),
      }),
      context.queryClient.ensureQueryData({
        queryKey: ["agents", "consent-policy", context.tenant.id],
        queryFn: () => fetchAgentConsentPolicy(context.tenant.id),
      }),
    ]),
  component: ApprovalThresholdsPage,
});
